import { css } from '@emotion/core'
import PropTypes, { element } from 'prop-types'
import React from 'react'

const Screen = ({
  header,
  footer,
  layout = ['flex-start', 'flex-start'],
  children,
  className,
}) => (
  <section
    className={className}
    css={css`
      display: grid;
      grid-template-rows: auto 1fr auto;
      min-height: 100vh;
    `}
  >
    <header>{header}</header>
    <main
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: ${layout[0]};
        align-items: ${layout[1]};
      `}
    >
      {children}
    </main>
    <footer>{footer}</footer>
  </section>
)

Screen.propTypes = {
  header: PropTypes.arrayOf(element),
  footer: PropTypes.arrayOf(element),
  layout: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.arrayOf(element),
  className: PropTypes.string,
}

Screen.defaultProps = {
  backgroundColor: `orchid`,
}

export default Screen
